// extracted by mini-css-extract-plugin
export default {"tabContainer":"styles_tabContainer__zaNkX","tabItem":"styles_tabItem__qpskN","tabItemActive":"styles_tabItemActive__QZfZL","card":"styles_card__MRp+d"};